import Lottie from 'lottie-react';
import MedicalBook from '../jsons/medical-book.json';


const LottieMedicalBook = props => {
  return <Lottie animationData={MedicalBook} loop={false} {...props} />;
};

export default LottieMedicalBook;
